export const AVAILABILITY_START_HOUR = 9;
export const AVAILABILITY_SLOT_COUNT = 12;
export const AVAILABILITY_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"] as const;
export const AVAILABILITY_DAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri"] as const;

export function getAvailabilitySlotIndex(minute: number): number {
  return Math.floor(minute / 60) - AVAILABILITY_START_HOUR;
}

export function formatAvailabilityHour(hour: number): string {
  const ampm = hour >= 12 ? "PM" : "AM";
  const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
  return `${displayHour}:00 ${ampm}`;
}
